import { ThunkDispatch, AnyAction, Store, configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { ProtocolState } from "./protocol/protocol.slice";
import { IProductsState } from "./products/products.slice";
import { UserState } from "./user/user.slice";
import { ListingsState } from "./listings/listings.slice";
import thunk from 'redux-thunk'


export type IState = {
  protocol: ProtocolState,
  products: IProductsState,
  listings: ListingsState,
  user: UserState };

const store = configureStore({ reducer: rootReducer, middleware: [thunk] });

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type TAppState = ReturnType<typeof rootReducer>;
export type TDispatch = ThunkDispatch<TAppState, void, AnyAction>;
export type TStore = Store<TAppState, AnyAction> & { dispatch: TDispatch };
export type TGetState = () => TAppState;

export default store;

